export const CalcAverage = (arr: number[]) =>
  arr.length === 0
    ? 0
    : arr.reduce((prevGrade, currGrade) => prevGrade + currGrade, 0) / arr.length;
